var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversationsNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 31.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36,14.62c0,8.08-8,14.63-18,14.63a21.72,21.72,0,0,1-6.53-1A17,17,0,0,1,1.69,31.5,1.69,1.69,0,0,1,.46,28.65a17.53,17.53,0,0,0,3.26-5.14A13,13,0,0,1,0,14.62C0,6.55,8.06,0,18,0S36,6.55,36,14.62Zm-2.25,0C33.75,7.8,26.69,2.25,18,2.25S2.25,7.8,2.25,14.62A10.64,10.64,0,0,0,5.36,22l1,1-.5,1.31A19.26,19.26,0,0,1,3,29.19a15.11,15.11,0,0,0,7.21-2.78l.92-.65,1.07.34A19.3,19.3,0,0,0,18,27C26.69,27,33.75,21.45,33.75,14.62ZM23.17,11.05l-3.58,3.57,3.59,3.58a.57.57,0,0,1,0,.8l-.79.79A.6.6,0,0,1,22,20a.55.55,0,0,1-.4-.17L18,16.21l-3.57,3.58A.6.6,0,0,1,14,20a.56.56,0,0,1-.41-.17L12.83,19a.57.57,0,0,1,0-.8l3.58-3.58-3.58-3.57a.57.57,0,0,1,0-.8l.79-.79A.6.6,0,0,1,14,9.29a.55.55,0,0,1,.4.17L18,13l3.58-3.58a.56.56,0,0,1,.4-.17.54.54,0,0,1,.4.17l.79.79A.55.55,0,0,1,23.17,11.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationsNo);
export default __webpack_public_path__ + "static/media/conversations-no.64a2c948b6c16e2fdde6c1f79cf36b88.svg";
export { ForwardRef as ReactComponent };